<script setup>
const runtimeConfig = useRuntimeConfig()
const beianNo = runtimeConfig.public.beian
</script>

<template lang="pug" scoped>
a(href="https://beian.miit.gov.cn/" target="_blank") {{ beianNo || '未备案' }}
</template>
